import script from "./OpsOrderManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./OpsOrderManagement.vue?vue&type=script&setup=true&lang=js"

import "./OpsOrderManagement.vue?vue&type=style&index=0&id=a294cd14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a294cd14"]])

export default __exports__